export default "__VITE_ASSET__BqCn45b___ 150w, __VITE_ASSET__B7z3mh$w__ 300w, __VITE_ASSET__Dg_W2Wh___ 450w";